import { render } from 'preact';
import { App } from './app/ui/app.js';
import './styles/global.css';

const root = document.getElementById('app');
if (root === null) {
  throw new Error('Missing #app root element');
}
render(<App />, root);
